import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportHomeComponent } from './report-home/report-home.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [ReportHomeComponent]
})
export class ReportsModule { }